export class SearchSettingsModal {

  constructor(maxPollCount:number, pollCount:number){
    this.maxPollCount = maxPollCount;
    this.pollCount = pollCount;
  }
    maxPollCount: number = 9;
    pollCount : number = 0;
  }


// WEBPACK FOOTER //
// ./src/app/customerservice/models/searchSettings-modal.ts